import { HelpIcon } from '@src/svg';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React, { FC, forwardRef, ReactElement, ReactNode } from 'react';

interface ITooltipElementProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode;
}

interface IInfoTooltip {
  children?: ReactElement<unknown, any>;
  title: ReactNode;
  className?: string;
  placement?: TooltipProps['placement'];
  enableNativeTitle?: boolean;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  slotProps?: TooltipProps['slotProps'];
  childrenContainerStyle?: React.CSSProperties;
  disableChildrenWrapper?: boolean;
}

const HelpIconComp = () => {
  return (
    <span className="icon">
      <HelpIcon />
    </span>
  );
};

const TooltipElement = forwardRef<HTMLSpanElement, ITooltipElementProps>(
  ({ children, ...props }, ref) => {
    return (
      <span
        {...props}
        ref={ref}
        style={{
          display: 'flex',
          width: '100%',
          minWidth: 0,
          ...props.style,
        }}
      >
        {children}
      </span>
    );
  }
);

const CustomizedTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  zIndex: 1000000,
  [`& .${tooltipClasses.tooltip}`]: {
    // TODO this was changed due to this ticket 4693
    // backgroundColor: 'gray',
    // color: '#FFF',
    // boxShadow:
    //   '0px 0px 2px 0px rgba(23, 26, 31, 0.12), 0px 17px 35px 0px rgba(23, 26, 31, 0.24);',
    // fontSize: 11,
    // fontWeight: 300,
    // border: '1px solid #FFF',
    // borderRadius: 0,
    backgroundColor: '#616165',
    lineHeight: '13px',
  },
}));

const InfoTooltip: FC<IInfoTooltip> = ({
  title,
  className,
  placement = 'top',
  children,
  enableNativeTitle = false,
  open,
  onOpen,
  onClose,
  slotProps,
  childrenContainerStyle,
  disableChildrenWrapper = false,
}) => {
  const nativeTitle =
    enableNativeTitle && typeof title === 'string' ? title : undefined;

  if (disableChildrenWrapper && children) {
    return (
      <CustomizedTooltip
        placement={placement}
        title={title}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        slotProps={slotProps}
      >
        {children}
      </CustomizedTooltip>
    );
  }

  return (
    <>
      <CustomizedTooltip
        placement={placement}
        title={title}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        slotProps={slotProps}
      >
        <TooltipElement
          className={className}
          title={nativeTitle}
          style={childrenContainerStyle}
        >
          {children ? children : <HelpIconComp />}
        </TooltipElement>
      </CustomizedTooltip>
    </>
  );
};

export default InfoTooltip;
